import { InjectionToken } from '@angular/core';

export const BaseUrlToken = new InjectionToken<string>('BaseUrlToken');
